const priceContracts: { cakeAddress: string; busdAddress: string; lpAddress: string } = {
  cakeAddress: '0xf75b23a09c6e126a2526e497517612825fd2a53c',
  busdAddress: '0x2d6b3691602f6a8f46d32d29260511f6a7f2869d',
  lpAddress: '0x82102267eA9484B30DFAc20FFE0a194D1e2cE48a',
}

export default priceContracts
